import React, { useState, useEffect } from "react";
import Wrappers from "../shared/Wrappers";
import Header from "./Header";
// import TotalProfit from "./TotalProfit";
import FilterButtons from "../shared/FilterButtons";
import AllInvoices from "./AllInvoices";
import UnpaidInvoices from "./UnpaidInvoices";
import PaidInvoices from "./PaidInvoices";
import Loader from "../../shared/loader";
import { GetAllAccounting } from "../../../services/admin/accounting";
import NotFoundIcon from "../../shared/NotFoundIcon";

const AccountingMain = () => {
  const [activeButton, setactiveButton] = useState(0);
  const [AllData, setAllData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [CurrentPage, setCurrentPage] = useState(1);
  const [SearchInputValue, setSearchInputValue] = useState("");
  const [SelectedDateCallback, setSelectedDateCallback] = useState("");

  const ButtonsArray = [
    { title: "All Invoices" },
    { title: "Paid Invoices" },
    { title: "Unpaid Invoices" },
  ];

  useEffect(() => {
    handleFetchAllAccounting();
  }, [activeButton, SearchInputValue, SelectedDateCallback, CurrentPage]);

  const handleFetchAllAccounting = async () => {
    const StatusType = ButtonsArray[activeButton]?.title || "";
    const Search = SearchInputValue || "";
    const Date = SelectedDateCallback || "";
    const Page = CurrentPage || 1;
    await GetAllAccounting(
      setLoading,
      setAllData,
      StatusType,
      Search,
      Date,
      Page
    );
  };

  return (
    <Wrappers>
      {loading && <Loader />}
      <Header
        Placeholder="Search for Sender, Receiver, Order, Type"
        SearchInputValue={SearchInputValue}
        setSearchInputValue={setSearchInputValue}
        setCurrentPage={setCurrentPage}
        SelectedDateCallback={SelectedDateCallback}
        setSelectedDateCallback={setSelectedDateCallback}
      />
      {/* <TotalProfit /> */}
      <FilterButtons
        ButtonsArray={ButtonsArray}
        activeButton={activeButton}
        setactiveButton={setactiveButton}
        setCurrentPage={setCurrentPage}
      />

      {!loading && (
        <>
          {AllData && AllData?.data && AllData?.data?.length > 0 ? (
            <>
              {activeButton === 0 && (
                <AllInvoices
                  data={AllData?.data || []}
                  CurrentPage={CurrentPage}
                  setCurrentPage={setCurrentPage}
                  Last_page={AllData?.last_page}
                  total_pages={AllData?.total_pages}
                />
              )}
              {activeButton === 1 && (
                <PaidInvoices
                  data={AllData?.data || []}
                  CurrentPage={CurrentPage}
                  setCurrentPage={setCurrentPage}
                  Last_page={AllData?.last_page}
                  total_pages={AllData?.total_pages}
                />
              )}
              {activeButton === 2 && (
                <UnpaidInvoices
                  data={AllData?.data || []}
                  CurrentPage={CurrentPage}
                  setCurrentPage={setCurrentPage}
                  Last_page={AllData?.last_page}
                  total_pages={AllData?.total_pages}
                />
              )}
            </>
          ) : (
            !loading && <NotFoundIcon MT="20" IconWidth="10" />
          )}
        </>
      )}
    </Wrappers>
  );
};

export default AccountingMain;
